<template>
  <form :class="[renew ? 'needs-validation' : '']" @submit.prevent="checkSeason" novalidate>
    <section class="card bg-white rounded mr-lg-3 mb-4 p-3 p-sm-4 col">
      <div class="mb-3">
        <h1 class="h2 mb-0" v-if="renew">Pay for Membership</h1>
        <h1 class="h2 mb-0" v-else><span class="d-none d-sm-inline">
          My </span>Membership <span class="d-none d-sm-inline">Details</span>
        </h1>
      </div>
      <div class="mb-3">
        <button class="d-block d-lg-none btn btn-block btn-primary" @click.prevent="memberModal">
          Need to add a member to your profile?
        </button>
      </div>
      <div v-if="renew">
        <div class="alert alert-info">Please ensure you select the membership season you wish to renew for from the drop down box below.</div>
        <div class="form-group">
          <label for="financialYear">Paying for Season</label>
          <div class="d-flex">
            <select class="form-control" id="financialYear" v-model="selectedSeason" @change="setSelectedSeason($event)">
              <option disabled></option>
              <option v-for="(startYear) in getProductYears()" :key="startYear.year" :value="startYear.year">{{startYear.description}}</option>
            </select>
            <button type="button" class="btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1" title="FAQs" @click.prevent="showSeasonInfoModal = true">
              <span class="sr-only">Frequently Asked Questions</span>
              <div class="btn-remove">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" aria-hidden="true" viewBox="0 0 512 512"><path fill="currentColor" d="M256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28zm7.67-24h-16c-6.627 0-12-5.373-12-12v-.381c0-70.343 77.44-63.619 77.44-107.408 0-20.016-17.761-40.211-57.44-40.211-29.144 0-44.265 9.649-59.211 28.692-3.908 4.98-11.054 5.995-16.248 2.376l-13.134-9.15c-5.625-3.919-6.86-11.771-2.645-17.177C185.658 133.514 210.842 116 255.67 116c52.32 0 97.44 29.751 97.44 80.211 0 67.414-77.44 63.849-77.44 107.408V304c0 6.627-5.373 12-12 12zM256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8z"/></svg>
              </div>
            </button>
          </div>
        </div>
      </div>
      <data-table :dataRows="rows" :dataColumns="columns" :options="options" class="flex-wrap">
        <tableSelectRowTemplate v-if="renew" slot-scope="{ row }" slot="expandedSelect" :row="row" class="z-1 p-3" :options="{ showIfInactive: true }" />
        <tableTextTemplate slot-scope="{ row }" slot="expandedHeader" :text="row.first_name + ' ' + row.last_name" :link="'Member Profile'" :slug="row.id" :tab="'loading'" :row="row" :options="{ showLinks: true, expandMobile: true, showActive: false }" />
        <tableDropdownTemplate slot-scope="{ row }" slot="expandedCustom" class="position-relative z-1 order-1 flex-grow-1 w-100 mt-2" :row="row" v-if="renew" :options="{ showIfInactive: true }" />
        <div slot-scope="{ row }" slot="expandedRow">
          <ul class="list-unstyled mb-0 pt-2">
            <li>
              <strong>Membership No: </strong>
              <tableTextTemplate :text="row.member_number" :row="row" :options="{ showPrimary: true, inline: true, showActive: true }" />
            </li>
            <li v-if="!renew">
              <strong>Membership Type: </strong>
              <tableTextTemplate :text="row.financial ? row.type : ''" :row="row" />
            </li>
          </ul>
        </div>
      </data-table>

      <div class="sticky-bottom alert bg-primary text-white d-lg-flex align-items-center text-center text-lg-left" role="alert" v-if="selectedRows.length > 0 && this.renew">
        <div class="flex-grow-1 mb-2 mb-lg-0 pr-3">
          <strong>You have selected: </strong>
          <span v-for="(row, i) in selectedRows" :key="i">
            {{ selectedRows | commaSeparateUsers(i) }}
          </span>
        </div>
        <button :class="['btn btn-block-mob text-nowrap', processing ? 'btn-primary-dark' : 'btn-outline-white']" type="submit" @click="handleSubmit" v-if="selectedRows.length > 0">
          {{ !processing ? 'Check Out' : '' }}
          <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
        </button>
        <button class="btn btn-block-mob btn-outline-white ml-lg-2" @click.prevent="deselectAll">Cancel</button>
      </div>
    </section>

    <desktop-action-bar v-if="renew && (user != 'Secretary' || user != 'SecretaryOnly')">
      <h3 class="h6 mb-0">{{memberUpdate.filter((member) => member.type).length ? 'Members added' : 'Please select members to Check Out'}}</h3>
        <table class="table table-borderless">
          <tbody>
            <tr v-for="(type, index) in memberUpdate" :key="'selected' + type.id + index">
              <td class="pl-0" v-if="type.type">{{type.type}}</td>
              <td class="pr-0" align="right" v-if="type.price">${{type.price}}</td>
            </tr>
          </tbody>
        </table>
        <button :class="['btn btn-block my-2', processing ? 'btn-primary-dark' : 'btn-primary']" type="submit" @click="handleSubmit" v-if="$store.getters.selectedRows.length > 0">
          {{ !processing ? 'Check Out' : '' }}
          <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
        </button>
        <div class="d-flex justify-content-between align-items-center" v-if="$store.getters.selectedRows.length > 0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.4 39.6" width="25" height="16" aria-labelledby="mastercard"><title id="mastercard">Mastercard</title><circle cx="19.5" cy="19.7" r="19" fill="#ee0005"/><circle cx="43" cy="19.7" r="19" fill="#f9a000"/><path fill="#ff6300" d="M24.1 19.7a19 19 0 0 0 7.2 14.9c4.4-3.5 7.2-8.8 7.2-14.9S35.6 8.3 31.3 4.8a19 19 0 0 0-7.2 14.9z"/></svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 505 153" width="35" height="11" aria-labelledby="visa"><title id="visa">Visa</title><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><path fill="#3c58bf" d="M185.3 149L210.9 5h40l-24.8 144z"/><path fill="#293688" d="M185.3 149L218.1 5h32.8l-24.8 144z"/><path fill="#3c58bf" d="M371 6.6C363 3.4 350 .2 334 .2c-40 0-68.8 20-68.8 48.8 0 21.6 20 32.8 36 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"/><path fill="#293688" d="M371 6.6C363 3.4 350 .2 334 .2c-40 0-61.6 20-61.6 48.8 0 21.6 12.8 32.8 28.8 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"/><path fill="#3c58bf" d="M439.7 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-31.2zm-18.4 96c2.4-7.2 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"/><path fill="#293688" d="M449.3 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-21.6zm-28 96c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"/><path fill="#3c58bf" d="M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-43.2l-40.8 100z"/><path fill="#293688" d="M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-35.2l-48.8 100z"/><path fill="#ffbc00" d="M.5 5l7.2 1.6C59 18.6 94.1 49 107.7 85L93.3 17C91 7.4 83.7 5 75 5H.5z"/><path fill="#f7981d" d="M.5 5c51.2 12 93.6 43.2 107.2 79.2L94.1 27.4A19.5 19.5 0 0 0 75 12.2L.5 5z"/><path fill="#ed7c00" d="M.5 5c51.2 12 93.6 43.2 107.2 79.2L98.1 53c-2.4-9.6-5.6-19.2-16.8-23.2L.5 5z"/><g fill="#051244"><path d="M151.7 101l-27.2-27.2-12.8 30.4-3.2-20c-7.2-24-30.4-50.4-56-63.2l36 128h43.2l20-48zM226.1 149l-34.4-35.2-6.4 35.2zM318.1 99.4c3.2 3.2 4.8 5.6 4 8.8 0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 25.6 0 46.4-7.2 58.4-20l-34.4-33.6zM364.5 149h37.6l8-24h51.2l4.8 24h38.4L491 90.6l-48-46.4 2.4 12.8s8 36 9.6 44h-33.6c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4"/></g></g></svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 12" width="26" height="18" aria-labelledby="claimoucher"><title id="claimoucher">Claim Voucher</title><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><g><path fill="#231815" d="M8 6.5H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5s-.2.5-.5.5zM8 4H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5S8.3 4 8 4z"/><path fill="#231815" d="M15.5 12h-14C.7 12 0 11.3 0 10.5v-9C0 .7.7 0 1.5 0h14c.8 0 1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5zM1.5 1c-.3 0-.5.2-.5.5v9c0 .3.2.5.5.5h14c.3 0 .5-.2.5-.5v-9c0-.3-.2-.5-.5-.5h-14z"/><path fill="#231815" d="M13.5 9h-10c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10c.3 0 .5.2.5.5s-.2.5-.5.5z"/><g><path fill="#231815" d="M13.5 6.8h-2.6c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h2.6c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5zm-2.1-1H13v-2h-1.6v2z"/></g></g></g></svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" width="22" height="27" aria-labelledby="banktransfer"><title id="banktransfer">Bank Transfer</title><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><g><path fill="#231815" d="M11.5 17h-9A2.5 2.5 0 0 1 0 14.5v-12C0 1.1 1.1 0 2.5 0h9C12.9 0 14 1.1 14 2.5v12c0 1.4-1.1 2.5-2.5 2.5zm-9-16C1.7 1 1 1.7 1 2.5v12c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-12c0-.8-.7-1.5-1.5-1.5h-9z"/><path fill="#231815" d="M11.5 13h-9c-.3 0-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zM3 12h8V3H3v9z"/><g><path fill="#231815" d="M7 15.6a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7c0-.3.1-.5.3-.7a1 1 0 0 1 1.4 0c.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 0 1-.7.3z"/></g></g></g></svg>
        </div>
    </desktop-action-bar>

    <desktop-action-bar v-else>
      <button class="d-none d-lg-block btn btn-block btn-primary" @click.prevent="memberModal">
        Need to add a member to your profile?
      </button>
    </desktop-action-bar>

    <modal v-if="showSeasonInfoModal" @close="showSeasonInfoModal = false">
      <h3 slot="header" class="modal-title">Frequently Asked Questions</h3>
      <div slot="body">
        <ul>
          <li>
            <strong>When does the ACA Financial Year start & finish?</strong>
            <p>The ACA competition year runs from 01 January through until 31 December each year.</p>
          </li>
          <li>
            <strong>Where can I find a copy of the invoice for my paid membership?</strong>
            <p>Once you have selected 'My Profile' from the menu, please go to the 'My Financials' tab and you will find invoices associated with your membership renewal that are available for download. You will also receive a PDF copy emailed directly to you each time you renew your membership.</p>
          </li>
          <li>
            <strong>My Rider Status is incorrect & I am unable to change it - what do I do?</strong>
            <p>Please contact the ACA Office on <a href="tel:0746223110" target="_blank">(07) 4622 3110</a> and a member of the team will be able to fix this up for you. They are also able to adjust your DOB, Gender or Member Number if these are not correct.</p>
          </li>
          <li>
            <strong>I only renewed my membership in January, does this roll over into the next season?</strong>
            <p>Unfortunately no, we do not offer memberships on a rolling basis. You must be financial for the season in which you are choosing to compete and this is why it is best to renew at the start of the season in order to get as much value as possible out of your membership.</p>
          </li>
          <li>
            <strong>I paid my membership via direct debit but I am not listed as financial on Campdraft One. When will this change?</strong>
            <p>When paying your membership via direct deposit or voucher there will be a slight delay to allow for this to be processed by the ACA Office Team. We ask that you stay patient with us throughout this process; however, if you think something has been missed please do not hesitate to contact our office on <a href="tel:0746223110" target="_blank">(07) 4622 3110</a> or email us at <a href="mailto:aca@campdraft.com.au" target="_blank" rel="noreferrer">aca@campdraft.com.au</a> and we can follow this up for you. Paying via card to renew your membership are directly linked with Campdraft One and the only way to guarantee an instant financial status.</p>
          </li>
          <li>
            <strong>I am not sure of my rider status or which zone I reside in?</strong>
            <p>Please refer to our website - <a href="//campdraft.com.au" target="_blank">campdraft.com.au</a> - and go to our information tab. Here you will find a wealth of knowledge including the General Information Competition Rules & Guidelines, our Fees & Charges Schedule and our Zone list.</p>
          </li>
        </ul>
      </div>
      <div slot="footer">
        <button class="btn btn-outline-primary" @click.prevent="showSeasonInfoModal = false">Close</button>
      </div>
    </modal>

    <modal v-if="showMemberModal" @close="showMemberModal = false">
      <div slot="body">
        <div class="alert alert-warning">
          Members can only be added to your profile via contacting the ACA Office on 07 4622 3110 Monday to Friday 8:30am to 4pm.
        </div>
      </div>
    </modal>

    <modal v-if="showSeasonConfirmModal" @close.prevent="showSeasonConfirmModal = false">
      <h3 slot="header" class="modal-title">Season Confirmation</h3>
      <div slot="body" class="text-center">
        <p>Please confirm your selected season: <span class="badge badge-primary">{{ Number(selectedSeason) }}</span></p>
        <p>Note: The ACA Financial/Membership Year runs from 1 January to 31 December.</p>
      </div>
      <div slot="footer">
        <button class="btn btn-outline-primary" @click.prevent="showSeasonConfirmModal = false">Cancel</button>
        <button class="btn btn-primary" @click="checkout">Confirm</button>
      </div>
    </modal>

  </form>
</template>

<script>
import axios from 'axios'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'
import tableSelectRowTemplate from '@/components/DataTableFields/SelectRow'
import tableDropdownTemplate from '@/components/DataTableFields/Dropdown'
import modal from '@/components/Modal'
import DesktopActionBar from '@/components/DesktopActionBar'

export default {
  filters: {
    commaSeparateUsers(list, index) {
      return `${list[index].first_name} ${list[index].last_name}${index === list.length - 1 ? '' : ','}`
    }
  },
  name: 'MembersProfileMembership',
  props: ['memberDetails', 'renew', 'child', 'preselectedYear'],
  mixins: [HANDLESUBMIT],
  components: {
    'data-table': dataTable,
    tableTextTemplate,
    tableSelectRowTemplate,
    tableDropdownTemplate,
    modal,
    DesktopActionBar
  },
  data() {
    return {
      showModal: false,
      user: localStorage.role,
      currentUser: localStorage.userID,
      showSeasonInfoModal: false,
      showSeasonConfirmModal: false,
      memberUpdate: [],
      storeMember: (this.child ? this.$store.state.childMember : this.$store.state.viewedMember),
      rows: [],
      columns: [
        {
          label: 'First Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.first_name" :link="'Member Profile'" :slug="row.id" :tab="'loading'" :row="row" :options="{ showLinks: true }" />`
          }),
          representedAs(row) { return `${row.first_name}` }
        },
        {
          label: 'Last Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.last_name" :link="'Member Profile'" :slug="row.id" :tab="'loading'" :row="row" :options="{ showLinks: true, showActive: true }" />`
          }),
          representedAs(row) { return `${row.last_name}` }
        },
        {
          label: 'Membership No.',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          filterable: false,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.member_number" :row="row" :options="{ showPrimary: true }" />`
          }),
          representedAs: 'member_number'
        },
        {
          label: 'Membership Type',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          filterable: false,
          sortable: this.renew ? false : true,
          component: ({
            props: ['row'],
            components: { tableDropdownTemplate, tableTextTemplate },
            template: this.renew ? `<tableDropdownTemplate :row="row" :options="{ showIfInactive: true }" />` : `<tableTextTemplate :row="row" />`
          }),
          representedAs: 'type'
        }
      ],
      options: {
        loading: true,
        flexWrap: true
      },
      showMemberModal: false,
      processing: false,
      selectedSeason: this.preselectedYear || false
    }
  },
  mounted() {
    this.refreshUserData()
  },
  methods: {
    deselectAll() {
      this.$store.commit('deselectAllRows')
      this.$emit('noRenew')
    },
    getTotal() {
      this.memberUpdate.forEach((member) => {
        member.type = member.membership_type ? member.membership_type.name : null
        member.typeId = member.membership_type ? member.membership_type.id : null
        member.price = member.membership_type ? member.membership_type.price : null
      })
    },
    getProductYears() {
      let products = [] // eslint-disable-line prefer-const
      let years = [] // eslint-disable-line prefer-const
      let distinctYears = [] // eslint-disable-line prefer-const

      this.rows.forEach((row) => {
        row.product_options.forEach((product) => {
          products.push(product)
        })
      })

      distinctYears = [...new Set(products.map(product => product.start_year))]

      distinctYears.forEach((year) => {
        if (year) {
          const description = `January 1, ${year} to December 31, ${year}`
          years.push({ year, description })
        }
      })

      return years
    },
    setSelectedSeason(event) {
      this.$store.commit('deselectAllRows')
      this.rows.forEach(row => delete row.membership_type)
      this.memberUpdate = []
      this.selectedSeason = event.target.value
      this.filterProductOptions(event.target.value)
    },
    filterProductOptions(year) {
      this.rows.forEach((row) => {
        row.filtered_product_options = row.product_options.filter(product =>
          parseInt(product.start_year, 10) === parseInt(year, 10) && product.active
        )
        row.selectedSeason = this.selectedSeason
        // row.isFinancial = row.financial_years ? row.financial_years[row.selectedSeason] : false
        row.isFinancial = row.financial
      })
    },
    memberModal() {
      this.showMemberModal = true
    },
    // Get user list
    refreshUserData() {
      axios.get(`${this.$api}/user/${this.storeMember ? this.storeMember.id : this.memberDetails.id}`).then((response) => {
        this.updateList(response.data.data)
      }).catch(() => {
        this.updateList(this.memberDetails)
      })
    },
    // Update user list
    updateList(member) {
      let tempRows = []
      if (member.primary) {
        tempRows = [member.primary, member, ...member.primary.secondaries]
      } else {
        tempRows = [member, ...member.secondaries]
      }
      tempRows = tempRows.filter((thing, index, self) =>
        !thing.deleted_at && index === self.findIndex(t => (
          t.id === thing.id
        ))
      )
      tempRows.forEach((row) => {
        row.filtered_product_options = []
      })
      this.rows = [...tempRows]
      this.selectedSeason = this.preselectedYear || [...this.getProductYears()].pop()?.year
      this.filterProductOptions(this.selectedSeason)
      if (this.renew) {
        this.memberUpdate = [...this.$store.state.selectedRows]
        this.getTotal()
      }

      // Add checkbox field if renewing memberships
      if (this.renew) {
        this.columns.unshift({
          label: '',
          field: '',
          headerClass: 'column-lg-small d-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableSelectRowTemplate },
            template: `<tableSelectRowTemplate :row="row" :options="{ showIfInactive: true }" />`
          })
        })
      }
      this.options.loading = false
    },
    checkSeason() {
      this.checkValidity()
      setTimeout(() => {
        if (this.formComplete) {
          this.showSeasonConfirmModal = true
        }
      }, 1)
    },
    checkout() {
      this.processing = true
      setTimeout(() => {
        if (this.$store.getters.selectedRows.length && this.formComplete) {
          this.memberUpdate = [...this.$store.getters.selectedRows]
          this.memberUpdate.forEach((member, index) => {
            this.$store.state.renewMembershipTypes.forEach((typeRow) => {
              if (typeRow.id === member.id && typeRow.membership_type) {
                this.memberUpdate[index].membership_type = typeRow.membership_type
                this.memberUpdate[index].type = typeRow.membership_type
                this.$store.commit('setSelectedRows', this.memberUpdate)
              }
            })
          })
          const tempRows = []
          const parentId = this.$store.state.selectedRows.some(row => row.parent_id) ? this.$store.state.selectedRows.find(row => row.parent_id).parent_id : this.$store.state.selectedRows[0].id
          this.$store.getters.selectedRows.map((item, index) => tempRows.splice(index, 1, item))
          axios.post(`${this.$api}/total-cart`, { data: tempRows.map(user => user.type.id), user_id: parentId }).then((response) => {
            this.processing = false
            if (response.data.status === 'success') {
              const users = response.data
              tempRows.map((item) => { // assign user attributes to every user (accessed user is the only one with these attributes)
                const tempItem = item
                tempItem.attributes = this.memberDetails.attributes
                tempItem.parent_id = parentId
                return tempItem
              })
              users.users = tempRows
              users.payer_user_id = parentId
              users.payer_email = this.memberDetails.attributes && this.memberDetails.attributes.email
                ? this.memberDetails.attributes.email
                : ''
              this.$store.commit('updateCartMembers', users)
              this.$router.push({ name: 'My Membership Cart', params: { backTo: 'pay', preselectedYear: String(this.selectedSeason) } })
            }
          }).catch((error) => {
            this.processing = false
            // eslint-disable-next-line
            console.log(error)
          })
        } else {
          this.processing = false
        }
      }, 10)
    }
  },
  beforeDestroy() {
    this.$emit('noRenew')
  },
  computed: {
    rowsUpdated() {
      return this.$store.state.rowsUpdated
    },
    selectedRows() {
      return this.$store.state.selectedRows
    },
    viewedMember() {
      return this.$store.state.viewedMember
    },
    childMember() {
      return this.$store.state.childMember
    }
  },
  watch: {
    selectedRows: {
      deep: true,
      handler() {
        this.memberUpdate = [...this.$store.state.selectedRows]
        this.getTotal()
      }
    },
    rowsUpdated() {
      this.memberUpdate = [...this.$store.state.selectedRows]
      this.getTotal()
    },
    viewedMember: {
      deep: true,
      handler() {
        this.rows = this.renew ? this.$store.state.viewedMember ? [this.$store.state.viewedMember] : this.memberDetails.financial === 0 ? [this.memberDetails] : [] : [this.memberDetails]
        this.rows = this.rows.concat(this.renew ? this.$store.state.viewedMember ? this.$store.state.viewedMember.secondaries.filter(member => member.primary !== null) : this.$store.state.viewedMember.primary ? this.$store.state.viewedMember.primary.secondaries.filter(member => member.primary !== null) : this.memberDetails.secondaries.filter(member => member.financial === 0) : this.memberDetails.secondaries)
        // Archived (soft-deleted) primary/secondary members are never offered for payment here.
        this.rows = this.rows.filter(row => !row.deleted_at)
      }
    },
    childMember: {
      deep: true,
      handler() {
        if (this.$isAdmin && this.child) {
          this.rows = this.renew ? this.$store.state.childMember ? [this.$store.state.childMember] : this.memberDetails.financial === 0 ? [this.memberDetails] : [] : [this.memberDetails]
          this.rows = this.rows.concat(this.renew ? this.$store.state.childMember ? this.$store.state.childMember.primary ? this.$store.state.childMember.primary.secondaries.filter(member => member.primary !== null) : this.$store.state.childMember.secondaries.filter(member => member.primary !== null) : this.memberDetails.secondaries.filter(member => member.financial === 0) : this.memberDetails.primary.secondaries)
          // Archived (soft-deleted) primary/secondary members are never offered for payment here.
          this.rows = this.rows.filter(row => !row.deleted_at)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/MyMembership/MyMembershipMembership.vue